import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the quantity of the given `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{`.`}<br parentName="p"></br>{`
`}{`If quantity is `}<inlineCode parentName="p">{`0`}</inlineCode>{`, the line item is removed from the cart.`}<br parentName="p"></br>{`
`}{`The `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` price is updated as described in `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem-price-selection"
        }}>{`LineItem Price selection`}</a>{`.`}</p>
      <p parentName="section">{`ChangeLineItemQuantity does not support changing the shipping details when multiple shipping addresses are set for one line item. `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#remove-lineitem"
        }}>{`RemoveLineItem`}</a>{` and `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#add-lineitem"
        }}>{`AddLineItem`}</a>{` support this, but not ChangeLineItem.
This is the case because it is not possible to deduct how the distribution of sub-quantities should be adapted in accordance with the overall change in the line item quantity.
Thus, the `}<inlineCode parentName="p">{`shippingDetails`}</inlineCode>{` field will be kept in its current state to avoid data loss.
Use `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#set-lineitemshippingdetails"
        }}>{`SetLineItemShippingDetails`}</a>{` in combination with this update action in one cart update command to change the line item quantity and shipping details together.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeLineItemQuantity"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`ID of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitem"
          }}>{`LineItem`}</a>{` in the cart.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`quantity`}</inlineCode>{` - Number - Required`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalPrice`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#money"
          }}>{`Money`}</a>{` - Optional`}<br parentName="li"></br>
          {`Sets the line item `}<inlineCode parentName="li">{`price`}</inlineCode>{` to the given value when changing the quantity of a line item with the `}<inlineCode parentName="li">{`ExternalPrice`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitempricemode"
          }}>{`LineItemPriceMode`}</a>{` `}<inlineCode parentName="li">{`priceMode`}</inlineCode>{`.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTotalPrice`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externallineitemtotalprice"
          }}>{`ExternalLineItemTotalPrice`}</a>{` - Optional`}<br parentName="li"></br>
          {`Sets the line item `}<inlineCode parentName="li">{`price`}</inlineCode>{` and `}<inlineCode parentName="li">{`totalPrice`}</inlineCode>{` to the given values when changing the quantity of a line item with the `}<inlineCode parentName="li">{`ExternalTotal`}</inlineCode>{` `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitempricemode"
          }}>{`LineItemPriceMode`}</a>{` `}<inlineCode parentName="li">{`priceMode`}</inlineCode>{`.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      